module.exports = __webpack_public_path__ + "img/fwg_farmerstoken.1e246ba.png";